/*eslint-disable */

import axios from 'axios';
import toast from '@/services/toast';

export default {
  name: 'create-new-models',
  components: {},
  props: ['selectedModelInfo'],
  data() {
    return {
      useModelFirstStep: true,
      useModelSecondStep: false,
      submitted: false,
      patient_name:'',
      predictionFilesDescribe:[],
      predictionAlertState:false,
      describeListNext:null,
      modelOutputData:null,
      modelTrainedLoader:false,
      readOnlyPredictionField:false
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    newPredictionForModelMethod(){
      this.modelOutputData = null
      this.patient_name = ''
      this.useModelFirstStep = true
      this.useModelSecondStep = false
      this.readOnlyPredictionField = false
    },
    stepFirstUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
            this.$store.dispatch('getAttrOfTrainedForUseModelsFun',{id:this.selectedModelInfo.id}).then((res)=>{
              this.predictionFilesDescribe = res.data.data.results
              this.describeListNext = res.data.data.next
              this.useModelFirstStep = false
              this.useModelSecondStep = true
              this.submitted =  false
            })
          return;
        }
      })
    },
    readOnlyDisabledMethod(){
      this.readOnlyPredictionField = false
    },
    nextDescribeListMethod(url){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          axios.get(url).then((response) => {
              this.describeListNext = response.data.data.next
              this.predictionFilesDescribe = [].concat(response.data.data.results,this.predictionFilesDescribe);
              this.submitted = false
            });
          return;
        }
      })
    },
    predictionAllFieldCheckingFun(){ 
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.predictionAlertState = true
        }
      })
    },
    stepSecondUseFormMethod() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          this.modelTrainedLoader = true
          let data = {
            input_list : this.predictionFilesDescribe,
            model : this.selectedModelInfo.id,
            run : true,
            patient_name:this.patient_name
          } 
            this.$store.dispatch('modelsUsingForAiDashFun', data)
            .then((res) => {  
              this.modelOutputData = res.data.data
              toast.success(res.data.msg || "Request processed successfully.");
              this.modelTrainedLoader = false
              this.readOnlyPredictionField = true
              this.submitted =  false
            }).catch((err) => {
              this.modelTrainedLoader = false
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        }
      })
    },
    draftUsingCurrentModelsMethod(){
      let data = {
        input_list : this.predictionFilesDescribe,
        model : this.selectedModelInfo.id,
        run : false,
        patient_name:this.patient_name
      } 
      this.$store.dispatch('modelsUsingForAiDashFun', data)
    },
    validArrCheckOfValueMethod(val){
      return Array.isArray(val)
    }
  }
}